export enum BankAccountType {
Current,
Savings,
}
